import {
  Autocomplete, Button, TextField, Typography,
} from '@mui/material';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { TranscriptionDialogContext } from '../../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';
import LANGUAGES_LIST from '../../../../../utils/languages';
import YesNoComponent from './YesNoComponent';
import {
  TrackingCategory,
  trackingService,
  TrackingTranscriptionParams,
} from '../../../../../services';

export interface LyricsProps {
  setCurrentStep: (step: number) => void;
}

const useStyles = makeStyles()(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  button: {
    marginTop: 16,
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

const Lyrics: React.FC<LyricsProps> = ({ setCurrentStep }) => {
  const { setSettings } = React.useContext(TranscriptionDialogContext);
  const [hasLyrics, setHasLyrics] = React.useState(false);
  const [lang, setLang] = React.useState<string | undefined>('en');
  const { t } = useTranslation();

  const { classes } = useStyles();
  const handleClick = (lyrics: boolean) => {
    if (lyrics) {
      setHasLyrics(true);
    } else {
      setHasLyrics(false);
      setSettings({ lyrics: false, lang: undefined }, 'vocals');
      setCurrentStep(3);
    }
  };

  const handleLanguageChange = (_event: React.ChangeEvent<{}>, value: string) => {
    setLang(value);
  };

  const handleNext = () => {
    setSettings({ lyrics: true, lang }, 'vocals');
    trackingService.valueObjectEvent<{ language: string }>(
      TrackingCategory.Transcription,
      TrackingTranscriptionParams.action.lyrics,
      { language: lang },
    );
    setCurrentStep(3);
  };

  return (
    <>
      <div className={classes.container}>
        <YesNoComponent handleClick={handleClick} id="lyrics" />
        {hasLyrics && (
          <>
            <Typography variant="body1">{t('home.input.dialog.lyrics.language')}</Typography>
            <Autocomplete
              renderInput={(params) => (
                <TextField {...params} label={t('home.input.dialog.lyrics.language_select')} />
              )}
              defaultValue="en"
              options={Object.keys(LANGUAGES_LIST)}
              getOptionLabel={(option) => LANGUAGES_LIST[option as keyof typeof LANGUAGES_LIST]}
              onChange={handleLanguageChange}
            />
          </>
        )}
      </div>
      {hasLyrics && (
        <div className={classes.button}>
          <Button variant="contained" id="btn_wizard_lyrics_next" onClick={handleNext}>
            {t('home.input.dialog.next')}
          </Button>
        </div>
      )}
    </>
  );
};

export default Lyrics;
